var map = {
	"./Screen_0.png": "f8cc",
	"./Screen_1.png": "0940",
	"./Screen_2.png": "19bf",
	"./Screen_3.png": "7db5",
	"./Screen_4.png": "aa2c",
	"./Screen_5.png": "4967",
	"./Screen_6.png": "cd2a",
	"./Screen_7.png": "a241"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c59d";